import React, { useState } from 'react';
import { hasPinConfigured } from 'containers/EPG/selectors/pin.selectors';
import {
  hidePinForm,
  showPinForm,
} from 'containers/PinForm/actions/pinForm.actions';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { getTranslation } from 'utils/getTranslation';
import {
  SET_PROFILE_FORM_FIELD,
  SET_PROFILE_LAYOUT_TYPE,
} from '../redux/profile.types';
import { getNameConfig } from '../utils/profile.utils';

export const useProfileForm = ({ isEditing = false }) => {
  const dispatch = useDispatch();
  const statusPin = useSelector(hasPinConfigured);
  const translations = useSelector(state => state.translations);
  const nameLength = getNameConfig();
  const [showTooltip, setShowTooltip] = useState(false);
  const {
    configProfileForm: { user_image, firstname, is_kids },
    prevLayout,
    avatars,
  } = useSelector(state => state.profilesManager);
  const [profileForm, setProfileForm] = useState({
    firstname: firstname.slice(0, nameLength.maxLength),
    is_kids,
  });

  const handleChange = e => {
    showTooltip && setShowTooltip(false);
    if (e.target.value.length > nameLength.maxLength) return;
    setProfileForm(prev => ({
      ...prev,
      firstname: e.target.value.trimStart(),
    }));
  };

  const handleCheckChange = e => {
    if (isEditing && profileForm.is_kids && statusPin) {
      return dispatch(
        showPinForm({
          type: 'UNBLOCK_CHANNEL',
          title: getTranslation(
            'lockPIN_editProfile_subtitleKids_label',
            translations,
          ),
          onSuccess: () => {
            setProfileForm(prev => ({
              ...prev,
              is_kids: false,
            }));
            setShowTooltip(false);
            dispatch(hidePinForm());
          },
        }),
      );
    }

    setProfileForm(prev => ({
      ...prev,
      is_kids: e.target.checked,
    }));
    setShowTooltip(e.target.checked);
  };

  const handleCancelClick = () => {
    dispatch({
      type: SET_PROFILE_FORM_FIELD,
      payload: {
        user_image: avatars[avatars?.length - 1]?.user_image,
        is_kids: false,
        firstname: '',
        gamification_id: '',
      },
    });

    if (prevLayout === '') {
      return dispatch({
        type: SET_PROFILE_LAYOUT_TYPE,
        payload: 'SELECT_PROFILE',
      });
    }
    dispatch({
      type: SET_PROFILE_LAYOUT_TYPE,
      payload: isEditing ? 'MANAGE_PROFILES' : 'SELECT_PROFILE',
    });
  };

  const setFormAction = () => {
    const { firstname, is_kids } = profileForm;

    dispatch({
      type: SET_PROFILE_FORM_FIELD,
      payload: {
        user_image,
        is_kids,
        firstname,
      },
    });
  };

  return {
    nameLength,
    profileForm,
    setFormAction,
    handleChange,
    handleCheckChange,
    handleCancelClick,
    showTooltip,
    setShowTooltip,
  };
};
